import React from "react";
import { useNavigate } from "react-router-dom";
import ImageWithCache from "./ImageWithCache";
import { normalizeCardDigits, isMonoTransferAvatar } from "./receiptUtils";
import { formatMoney, cardQuery } from "./cardsStore";
import { useMaskBalance } from "./balanceVisibility";
import { listView } from "./fxStore";

// Для переказу показуємо номер картки в масці 4441114****4435
// (перші 6 цифр + **** + останні 4), інакше — звичайну назву.
function displayTxName(tx) {
  if (tx.category !== "Transfer") return listView(tx).name;
  const digits = normalizeCardDigits(tx.name);
  if (digits.length < 11) return tx.name;
  return `${digits.slice(0, 6)}****${digits.slice(-4)}`;
}

const VISIBLE_COUNT = 3; // скільки останніх операцій показуємо на головній

// Невидимі рядки тієї ж розмітки — добивають виписку до висоти трьох операцій
function GhostRows({ count }) {
  return Array.from({ length: Math.max(0, count) }, (_, i) => (
    <div className="transaction-element transaction-element--ghost" key={`ghost-${i}`} aria-hidden="true">
      <div className="transaction-name">
        <div className="transaction-img-con" />
        <p className="transaction-name-m">&nbsp;</p>
      </div>
      <p className="transaction-sum-m">&nbsp;</p>
    </div>
  ));
}

function StatementHeader({ onAll }) {
  return (
    <div className="transaction-header">
      <p className="transaction-header-m">Операції</p>
      <div className="transaction-header-btn" style={{ cursor: "pointer" }} onClick={onAll}>
        Усі <img className="transaction-header-img" src="/arrow.png" alt="Arrow" />
      </div>
    </div>
  );
}

// Порожня виписка заввишки як виписка з трьох операцій: шапка й рядки
// лишаються в розмітці невидимими, children — текст по центру блоку.
// Та сама заглушка стоїть на сторінці «Відкрити картку».
export function StatementPlaceholder({ className = "", children }) {
  return (
    <div className={`transactions-con empty ${className}`}>
      <StatementHeader />
      <div className="transactions-elements-con">
        <GhostRows count={VISIBLE_COUNT} />
        <div className="empty-statement">{children}</div>
      </div>
    </div>
  );
}

// cardId/currency — чия це виписка: «Усі» й деталі відкриваються для цієї ж картки
const Transactions = ({ transactions: allTransactions = [], cardId, currency = "UAH" }) => {
  const navigate = useNavigate();
  const maskBalance = useMaskBalance();

  const transactions = allTransactions
    .filter((tx) => tx && tx.name && tx.amount && tx.img && tx.date)
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, VISIBLE_COUNT)
    .map((tx) => ({ ...tx, formattedAmount: maskBalance(formatMoney(tx.amount, currency)) }));

  if (transactions.length === 0) {
    return (
      <div className="transactions-wrap">
        <StatementPlaceholder>
          <p className="empty-statement-title">Тут буде ваша виписка 🏄‍♂️</p>
          <p className="empty-statement-sub">Саме час почати користуватися<br />карткою, наприклад, поповнити мобільний!</p>
        </StatementPlaceholder>
      </div>
    );
  }

  return (
    <div className="transactions-wrap">
      <div className="transactions-con">
        <StatementHeader onAll={() => navigate(`/history${cardQuery(cardId)}`)} />
        <div className="transactions-elements-con">
          {transactions.map((tx) => (
            <div
              className="transaction-element"
              key={tx.id}
              data-id={tx.id}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/transaction/${tx.id}${cardQuery(cardId)}`)}
            >
              <div className="transaction-name">
                <div className="transaction-img-con">
                  <ImageWithCache className={`transaction-img-m ${isMonoTransferAvatar(tx) ? 'no-zoom' : ''}`} src={listView(tx).img} alt={tx.name} />
                </div>
                <p className="transaction-name-m">{displayTxName(tx)}</p>
              </div>
              <p className={`transaction-sum-m ${tx.type === "income" ? "income" : ""}`}>
                {tx.formattedAmount}
              </p>
            </div>
          ))}
          <GhostRows count={VISIBLE_COUNT - transactions.length} />
        </div>
      </div>
    </div>
  );
};

export default Transactions;
